import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(36, 24, 56, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

export const Modal = styled.div`
 width: 900px;
  max-height: 80vh;
  background: #fff;
  border-radius: 12px;
  overflow-y: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);

  position: relative;
  box-sizing: border-box;
  max-width: 100%;
  overflow-x: hidden;
`;

// Close affordance — parity with the other personalise popups
// (SessionBooking, VerifyClasses). Closing here dismisses WITHOUT saving and
// WITHOUT marking the checklist row complete; only "Save Preferences" ticks it.
export const CloseIcon = styled.img`
  position: absolute;
  top: 20px;
  right: 24px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  opacity: 0.6;
  &:hover { opacity: 1; }
`;

export const Header = styled.div`
  padding: 24px 32px;
  /* Keep the top-right corner clear for the absolutely positioned CloseIcon
     (right 24px + 20px wide) so it never lands on the Save / Retry button
     (JED-1269): 24 + 20 + 24px gap. */
  padding-right: 68px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`;

export const Title = styled.h2`
font-family: IBM Plex sans;
font-weight: 600;
font-size: 20px;
line-height: 28px;
letter-spacing: 1%;

`;

export const Subtitle = styled.p`
font-family: IBM Plex sans;
font-weight: 400;
font-size: 16px;
line-height: 20px;
letter-spacing: 0%;
color:#4B464F;

`;

export const SaveButton = styled.button`
  background: #3a1b85;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 900px;
  font-weight: 500;
  cursor: pointer;
  font-family:IBM Plex Sans;
  size:16px;
  line-height:24px;

  &:hover {
    background: #2f156b;
  }
`;

export const Content = styled.div`
  padding: 24px 32px;
  overflow-y:auto;
  flex-grow:1;
    box-sizing: border-box;   
  max-width: 100%;
  max-height: 60vh;
  background-color:#F8F8F8
  
   
`;

export const Card = styled.div`
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  display:flex;
  flex-direction:column;
  gap:20px;
  background-color: white;
`;

export const Question = styled.h3`
font-family: IBM Plex Sans;
font-weight: 500;
font-size: 19px;
line-height: 24px;
letter-spacing: 0%;

`;

export const Segmented = styled.div`
  display: flex;
  background: #FBF7FE;
  border-radius: 4px;
  padding: 4px;
  gap: 4px;
  overflow-x: auto;  
  max-width: 100%;
  box-shadow: 0px 1px 6px 0px #483D5B40 inset;
  border:1px solid #F1E6FC;
`;

export const SegmentButton = styled.button`
font-family: IBM Plex Sans;
font-weight: 400;
font-style: normal;
font-size: 16px;
line-height: 100%;
letter-spacing: 0%;
text-align: center;
 text-align: center;
  flex: 1 1 auto;      
  padding: 10px 12px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  background: ${({ active }) => (active ? '#7a00d6' : 'transparent')};
  color: ${({ active }) => (active ? '#fff' : '#333')};

  &:hover {
    background: ${({ active }) => (active ? '#6a00bf' : 'white')};
    border: 1px solid rgba(159, 159, 159, 1);
  }
  min-width: 0;   
`;

export const HelperText = styled.div`
font-family: IBM Plex Sans;
font-weight: 400;
font-style: Regular;
font-size: 16px;
line-height: 24px;
letter-spacing: 0%;
color:#4B464F;
display:flex;
align-items:center;
gap:5px;
`;

export const Footer = styled.div`
  padding: 16px 32px;
  display: flex;
  justify-content: center;
  background: #F8F8F8;
  flex-shrink: 0;

  @media (max-width: 480px) {
    padding: 12px 20px;
  }
`;

